import { RootState } from '../store';

export const selectPasswordProtection = (state: RootState) =>
  state.passwordProtection;

export const selectIsPasswordProtectionLocked = (state: RootState): boolean => {
  const { blockSettings, pass } = state.passwordProtection;
  return blockSettings && !!pass && !state.appData.passwordProtectionUnlocked;
};
